const PLATFORM_INTEGRATIONS = {
  onlyfans: 'onlyfans',
  beacons: 'beacons',
  tiktok: 'tiktok',
  storedrop: 'storedrop',
  linktreeLegacy: 'linktreeLegacy'
};

export default PLATFORM_INTEGRATIONS;
